import administration from './administration';

export default {
	administrationPage: administration
}